import { TNullable } from "../../contracts/TNullable"

export default function StringHelperService() {

  function isStringEmpty(targetString: string | TNullable): boolean {
    return !targetString?.trim();
  }

  function isStringNotEmpty(targetString: string | TNullable): boolean {
    return !isStringEmpty(targetString);
  }

  function PLURALIZE(count: number, targetString: string) {
    return `${count} ${targetString}${count > 1 ? 's' : ''}`
  }

  function NORMALIZE(value: string): string {
    return value.replace('].[', '_____').replace('[', '___').replace(']', '___');
  }

  function DENORMALIZE(value: string): string {
    return value.replace('_____', '].[').replace('___', '[').replace('___', ']');
  }


  // ---
  return {
    isStringEmpty, isStringNotEmpty, PLURALIZE, NORMALIZE, DENORMALIZE,
  }
}